// 研習資訊頁面
import { News } from "./News";
import { useEffect, useState } from "react";

export const Info = () => {
  const [allNews, setAllNews] = useState<any[]>([]);
  const [filteredNews, setFilteredNews] = useState<any[]>([]);
  const [query, setQuery] = useState('');

  const handleReset = () => {
    setQuery('');
    setFilteredNews(allNews);
  }


  const handleKeywordSearch = (keyword: string) => {
    setQuery(keyword);
    const filtered = allNews.filter((item) =>
      item.title.includes(keyword) || item.content.includes(keyword)
    );
    setFilteredNews(filtered);
  }

  return (
    <div>
      <div className="mb-20">
        <div className="flex items-center staticBanner bg-[#cbbef0] relative">
          <div className="staticBannerContent">
            <img
              src="/images/infoBanner.png"
              alt="banner"
              className="staticBannerImg"
            />
            <div className="text-base sm:text-lg md:text-3xl absolute w-[40%] max-w-[400px] translate-x-[59%] max-h-full overflow-auto">
              <h2 className="font-black text-primaryDark">教師數位研習資源</h2>
              <p className="text-secondaryDark mt-[0.5em] text-[0.65em] leading-normal">
                參加高雄市數位研習活動，掌握最新教學科技，提升教學智慧，讓學生學習效果更卓越！這裡專門提供教師的研習資訊，助您持續進步。
              </p>
            </div>
          </div>
        </div>
        <div className="staticSection !pb-0">
          <div className="sectionContent">
            <div className="border-2 border-headline relative text-base sm:text-2xl">
              <div className="flex justify-center items-center font-bold absolute left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white px-2 text-Headline text-nowrap">
                <span className="text-[0.55em]">〇〇〇</span>
                <h3 className="px-1">研習資訊</h3>
                <span className="text-[0.55em]">〇〇〇</span>
              </div>

              <div className="flex flex-col sm:flex-row justify-center gap-6 sm:gap-x-24 px-6 py-12 sm:py-20">
                <div className="mx-auto sm:mx-0 text-[0.9em]">
                  <a href="https://drive.google.com/drive/folders/1ME1bSl-3jMMoGHwO507TWYIbL-L_b-6B?usp=drive_link" target="_blank" rel="noreferrer">
                    <button className="roundedAnimationBtn bg-sky-400 text-white  flex-1">
                      <div className="p-2 sm:p-4 bg-white w-1/4 h-full">
                        <img src="/images/doc.svg" alt="" className="w-32 h-full object-contain object-center" />
                      </div>
                      <div className="grow ">研習公文</div>
                    </button>
                  </a>
                </div>

                <div className="mx-auto sm:mx-0 text-[0.9em]">
                  <a href="https://docs.google.com/spreadsheets/d/1Hw7alKPsWCRJyhq3y4xmimz8Z1ptgs2LSfXyMcr8c0I/edit?usp=drive_link" target="_blank" rel="noreferrer">
                    <button className="roundedAnimationBtn bg-primary text-white  flex-1">
                      <div className="p-2 sm:p-4 bg-white w-1/4 h-full">
                        <img src="/images/session.svg" alt="" className="w-32 h-full object-contain object-center" />
                      </div>
                      <div className="grow ">研習場次</div>
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        
        <div className='content text-Headline px-4 mx-auto'>
          <div className='text-lg lg:text-3xl w-fit border-b-4 border-primary font-medium mt-6 mb-4 lg:my-12 p-1 lg:p-3 mx-auto'>研習公告</div>
          {/* <div className="flex justify-center mb-6 lg:mb-8">
            <div className="hidden md:block md:w-auto lg:w-56 sm:mr-auto"></div> */}

          {/* Search box */}
          {/* <div className="flex-grow w-full sm:w-auto sm:max-w-96 mx-auto">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span id="basic-addon1" className="input-group-text !pr-0">
                    <img src={searchIcon} alt="" />
                  </span>
                </div>
                <input
                  type="text"
                  placeholder="主旨、內容關鍵字搜尋"
                  className="form-control"
                  onChange={(e) => handleKeywordSearch(e.target.value)}
                  value={query}
                />
                <div>
                  <button
                    type="button"
                    className="flex py-2 px-3 border border-l-0 border-[#ced4da] rounded-r-full"
                    onClick={() => handleReset()}
                  >
                    <img src={refreshIcon} alt="" />
                  </button>
                </div>
              </div>
            </div> 

          </div>*/}
          <News tag='研習資訊' />

          {/* <div className="text-center mt-8">
            
            <div className="text-primary">共{filteredNews.length}筆</div>
            
          </div> */}

        </div>

      </div>
    </div>
  );
};
